import { TimesheetModificationType } from '@/lib/api/company/timesheet/groupedTimesheet/types'

/**
 * Powód, dla którego przeliczona ewidencja stała się nieaktualna → klucz tłumaczenia.
 *
 * Jedno miejsce dla wszystkich znaczników (grid „Premia i nagroda" i lista kierowców):
 * ten sam kod przyczyny musi wszędzie dawać ten sam tekst, inaczej dwa ostrzeżenia o tej
 * samej ewidencji zaczną mówić co innego.
 */
const CAUSE_KEYS: Partial<Record<TimesheetModificationType, string>> = {
  [TimesheetModificationType.Activities]: 'timesheet.out-of-date-cause-activities',
  [TimesheetModificationType.DayType]: 'timesheet.out-of-date-cause-day-type',
  [TimesheetModificationType.Schedule]: 'timesheet.out-of-date-cause-schedule',
  [TimesheetModificationType.BusinessTrips]:
    'timesheet.out-of-date-cause-business-trips',
  [TimesheetModificationType.Contract]: 'timesheet.out-of-date-cause-contract',
  [TimesheetModificationType.Configuration]:
    'timesheet.out-of-date-cause-configuration',
}

/** Zwraca klucz tłumaczenia przyczyny albo null, gdy przyczyna nie jest znana. */
export function getOutOfDateCauseKey(
  cause: TimesheetModificationType | number | null | undefined,
): string | null {
  if (cause == null) {
    return null
  }

  return CAUSE_KEYS[cause as TimesheetModificationType] ?? null
}
